import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AirSavedCardModel } from "entities/AirSavedCard";
import { SeaSavedCardModel } from "entities/SeaSavedCard";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

export type FilterCardsState = SeaSavedCardModel | AirSavedCardModel;

const initialFilterCardsState: FilterCardsState[] = [];

const filteredCardsSlice = createSlice({
  name: "filteredCards",
  initialState: initialFilterCardsState,
  reducers: {
    setFilteredCardsAction: (_, action: PayloadAction<FilterCardsState[]>) => {
      return action.payload;
    },
    clearFilteredCardsAction: () => {
      return [];
    },
    removeFilteredCardAction: (state, action: PayloadAction<FilterCardsState>) => {
      return state.filter((card) => card.reference !== action.payload.reference);
    },
    appendFilteredCardsAction: (
      state,
      { payload: { data, unique = true } }: PayloadAction<{ data: FilterCardsState[]; unique?: boolean }>
    ) => {
      if (unique) {
        const referencesSet = new Set<string>();
        state.forEach((item) => {
          if (item.reference) {
            referencesSet.add(item.reference);
          }
        });

        data.forEach((item) => {
          if (item.reference && !referencesSet.has(item.reference)) {
            state.push(item);
          }
        });
        return state;
      }
      return state.concat(data);
    },
    updateFilterCardAction: (state, action: PayloadAction<FilterCardsState>) => {
      const targetCard = state.findIndex((card) => card.reference === action.payload.reference);
      if (targetCard !== -1) {
        state[targetCard] = action.payload;
      }
    },
  },
});

const filteredCardsBaseSelector = createBaseSelector(filteredCardsSlice);

registerSlice([filteredCardsSlice]);

export const filteredCardsStore = {
  actions: filteredCardsSlice.actions,
  selectors: {
    filteredCards: createSelector(filteredCardsBaseSelector, (s) => s),
  },
};
